module.exports = __webpack_public_path__ + "static/banner-right-img-4-84c249df7b62698a098896871c173019.png";